import { Component } from 'react';
import DoodleManager from './doodle-manager';

class DoodleStage extends Component<any> {
  _canvas: any;
  doodleManager: DoodleManager;
  constructor(props) {
    super(props);

    this._canvas = null;
    this.doodleManager = new DoodleManager();

    this.handleDraw = this.handleDraw.bind(this);
    this.handleDrawStart = this.handleDrawStart.bind(this);
    this.handleDrawEnd = this.handleDrawEnd.bind(this);
  }

  componentDidMount() {
    this.doodleManager.prepareCanvas(this._canvas);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.eraseAll !== this.props.eraseAll) {
      this.doodleManager.removeAllDrawnPaths();
    }
  }

  handleDraw(event) {
    const { left, top } = this._canvas.getBoundingClientRect();
    const pressedMouseButton =
      event.buttons !== undefined ? event.buttons : event.nativeEvent.which;
    const isTouchEvent = event.nativeEvent.constructor !== MouseEvent;
    const scale = this.props.zoomLevel / 100.0;

    if (this.props.pencilEnabled) {
      if (isTouchEvent) {
        if (event.touches.length === 1) {
          this.doodleManager.drawPoint(
            (event.touches[0].clientX - left) / scale,
            (event.touches[0].clientY - top) / scale
          );
        }
      } else {
        if (pressedMouseButton === 1) {
          this.doodleManager.drawPoint(
            (event.clientX - left) / scale,
            (event.clientY - top + 10) / scale
          );
        }
      }
    }
  }

  handleDrawStart(event) {
    if (this.props.pencilEnabled) {
      this.doodleManager.newPath();
    }
    this.handleDraw(event);
  }

  handleDrawEnd() {
    if (this.props.pencilEnabled) {
      this.doodleManager.endPath();
    }
  }

  render() {
    return (
      <div
        className={`doodle-stage ${
          this.props.pencilEnabled ? 'pencil-enabled' : ''
        } ${this.props.extraHeight ? 'extra-height' : ''}`}
        style={{
          transform: `scale(${this.props.zoomLevel / 100.0})`,
          transformOrigin: `${100.0 - this.props.zoomLevel}% ${
            50.0 - this.props.zoomLevel / 2
          }% 0px`,
        }}
      >
        <canvas
          ref={(canvasEl) => (this._canvas = canvasEl)}
          onMouseMove={this.handleDraw}
          onTouchMove={this.handleDraw}
          onMouseDown={this.handleDrawStart}
          onTouchStart={this.handleDrawStart}
          onMouseUp={this.handleDrawEnd}
          onTouchEnd={this.handleDrawEnd}
          onMouseLeave={this.handleDrawEnd}
          onMouseEnter={this.handleDrawStart}
        />
      </div>
    );
  }
}

export default DoodleStage;
